import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from '../../constants/pages';

import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { BadgesList } from './components/BadgesList';
import { TotadminPermission } from 'data/__generated__';

export const Badges = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.badges} />
                </HeaderTitle>
                <Link to="/badge/create">
                    <TotemPrimaryButton requiredPermissions={[TotadminPermission.BadgesManage]}>
                        Créer un badge
                    </TotemPrimaryButton>
                </Link>
            </Header>
            <Content>
                <BadgesList />
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;
